module.exports = __webpack_public_path__ + "img/1534036355.dac9a06e.jpg";